import { isMobile } from '../lib/helpers';
import useWindowWidth from './useWindowWidth';

export const useIsMobile = () => {
  const width = useWindowWidth();

  return isMobile(width);
};
